import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';

export class BlockFirmValidator {
    /**
     * @param blockfirmsCode list of firmscode to be blocked
     * @returns a observable that emits validation errors with name of blockFirmscodeExist if present, otherwise null.
     */
    public static checkBlockedFirmsCode(blockfirmsCode: string[]): AsyncValidatorFn {
        return (control: AbstractControl): Observable<ValidationErrors | null> => {
            if (blockfirmsCode.length > 0) {
                return of(
                    blockfirmsCode.some((firmsCode: string) => {
                        return firmsCode?.toLowerCase() === control.value?.toLowerCase();
                    })
                )
                    .pipe(delay(500))
                    .pipe(
                        map((exist) => {
                            return exist ? { blockFirmscodeExist: true } : null;
                        })
                    );
            }
            return of(null);
        };
    }
}
